import React from 'react'
import { ComingSoon } from '../../../../components/ComingSoon'

export default function GeneralSettings() {
  return (
    <ComingSoon heading="General Settings">
      <div className="text-sm text-gray-500 font-medium mt-4">🚧 Coming Soon Feature</div>
    </ComingSoon>
  )
}
